"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HeaderMenuCategory = _interopRequireWildcard(require("../HeaderMenuCategory"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HeaderMenuWishlist = function HeaderMenuWishlist(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    name = props.name,
    slug = props.slug,
    onToggleWishlist = props.onToggleWishlist,
    _props$counter = props.counter,
    counter = _props$counter === void 0 ? '1' : _props$counter,
    children = props.children,
    isCompact = props.isCompact,
    _props$isWhiteLabel = props.isWhiteLabel,
    isWhiteLabel = _props$isWhiteLabel === void 0 ? false : _props$isWhiteLabel,
    breakpoint = props.breakpoint,
    onHoverWishlist = props.onHoverWishlist,
    isHomepage = props.isHomepage;
  return /*#__PURE__*/_react["default"].createElement(CategoryWishlist, {
    className: className,
    isCompact: isCompact,
    name: name,
    slug: slug,
    onClick: onToggleWishlist,
    breakpoint: breakpoint,
    onMouseEnter: onHoverWishlist,
    isHomepage: isHomepage,
    $counter: counter,
    $isWhiteLabel: isWhiteLabel
  }, /*#__PURE__*/_react["default"].createElement(StyledNestedMenu, {
    hasItems: counter,
    isHomepage: isHomepage
  }, children));
};
var CategoryWishlist = (0, _styledComponents["default"])(_HeaderMenuCategory["default"]).withConfig({
  displayName: "HeaderMenuWishlist__CategoryWishlist",
  componentId: "sc-jq8hfi-0"
})(["height:100%;&:hover{", "::before{background:var(--black);color:var(--white);", "}}", "::before{display:flex;align-items:center;justify-content:center;", ";cursor:pointer;position:absolute;width:16px;height:16px;border-radius:50%;transform:translateX(15px);font-size:12px;font-style:normal;font-weight:500;color:var(--black);background:var(--white);", "}"], _HeaderMenuCategory.Icon, function (_ref) {
  var $isWhiteLabel = _ref.$isWhiteLabel;
  return $isWhiteLabel && (0, _styledComponents.css)(["color:var(--secondary);background:var(--white);"]);
}, _HeaderMenuCategory.Icon, function (_ref2) {
  var $counter = _ref2.$counter;
  return $counter && (0, _styledComponents.css)(["content:'", "';"], $counter);
}, function (_ref3) {
  var $isWhiteLabel = _ref3.$isWhiteLabel;
  return $isWhiteLabel && (0, _styledComponents.css)(["color:var(--white);background:var(--secondary);"]);
});
var StyledNestedMenu = (0, _styledComponents["default"])(_HeaderMenuCategory.NestedMenu).attrs({
  as: 'div'
}).withConfig({
  displayName: "HeaderMenuWishlist__StyledNestedMenu",
  componentId: "sc-jq8hfi-1"
})(["color:var(--black);box-shadow:var(--box-shadow);border-radius:var(--border-radius);background-color:var(--white);right:0;left:auto;padding-bottom:0;width:", ";"], function (props) {
  return props.hasItems ? '500px' : '350px';
});
var _default = exports["default"] = HeaderMenuWishlist;